module.exports = __webpack_public_path__ + "static/img/ao.11f61ca5.svg";